import { render, staticRenderFns } from "./GameModel.vue?vue&type=template&id=d788ac12"
import script from "./GameModel.vue?vue&type=script&lang=js"
export * from "./GameModel.vue?vue&type=script&lang=js"
import style0 from "./GameModel.vue?vue&type=style&index=0&id=d788ac12&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports